import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const GraceLoadingScreen = () => {
  const isTempo = useBrand(TEMPO);

  return (
    <div className="animate-in fade-in absolute inset-0 z-10 flex items-center justify-center rounded-lg backdrop-blur-sm duration-300">
      <div className="flex flex-col items-center">
        <div
          className={`h-12 w-12 animate-spin rounded-full border-4 border-solid border-charcoal-70 ${isTempo ? 'border-t-tempo-blue-90' : 'border-t-green-100'}`}
        />
        <p className="text-primary text-base">Reviewing your issue...</p>
      </div>
    </div>
  );
};

export default GraceLoadingScreen;
